import ADL from './ADLIndicator';
import AdvanceDecline from './AdvanceDeclineIndicator';
import AvgTrueRange from './AverageTrueRangeIndicator';
import AwesomeOscillator from './AwesomeOscillatorIndicator';
import BestWorst from './BestWorstIndicator';
import Bollinger from './BollingerBandsIndicator';
import BollingerBandWidth from './BollingerBandWidthIndicator';
import Chaikins from './ChaikinsIndicator';
import CommodityChannelIndex from './CommodityChannelIndexIndicator';
import CRS from './CRSIndicator';
import DividendYield from './DividendYieldIndicator';
import DMI from './DMIIndicator';
import EMA from './EMAIndicator';
import GSRecommendation from './GSRecommendationIndicator';
import HighLow from './HighLowIndicator';
import HorizontalAnnotation from './HorizontalAnnotationIndicator';
import IchimokuCloud from './IchimokuCloudIndicator';
import LinearRegression from './LinearRegressionIndicator';
import MACD from './MACDIndicator';
import MAE from './MAEIndicator';
import MassIndex from './MassIndexIndicator';
import Momentum from './MomentumIndicator';
import MoneyFlow from './MoneyFlowIndicator';
import MoneyFlowIndex from './MoneyFlowIndexIndicator';
import NRV from './NRVIndicator';
import OnBalanceVolume from './OnBalanceVolumeIndicator';
import PERange from './PERangeIndicator';
import PERatio from './PERatioIndicator';
import PercentB from './PercentBIndicator';
import PreviousClose from './PreviousCloseIndicator';
import PriceChannel from './PriceChannelIndicator';
import Price from './PriceIndicator';
import PROC from './PROCIndicator';
import PSAR from './PSARIndicator';
import Revenues from './RevenuesIndicator';
import RollingDividend from './RollingDividendIndicator';
import RollingEPS from './RollingEPSIndicator';
import RSI from './RSIIndicator';
import SectorIndustry from './SectorIndustryIndicator';
import SMA from './SMAIndicator';
import Stochastics from './StochasticsIndicator';
import TSF from './TSFIndicator';
import UltimateOscillator from './UltimateOscillatorIndicator';
import UpDown from './UpDownIndicator';
import UpDownRatio from './UpDownRatioIndicator';
import Volume from './VolumeIndicator';
import VolumeByPrice from './VolumeByPriceIndicator';
import VROC from './VROCIndicator';
import VWAP from './VWAPIndicator';
import WilliamsPctR from './WilliamsIndicator';
import WMA from './WMAIndicator';
import YieldSpread from './YieldSpreadIndicator';

export default new Map([
	['adl', ADL],
	['advancedecline', AdvanceDecline],
	['avgtruerange', AvgTrueRange],
	['awesomeoscillator', AwesomeOscillator],
	['bestworst', BestWorst],
	['bollinger', Bollinger],
	['bollingerbandwidth', BollingerBandWidth],
	['chaikins', Chaikins],
	['commoditychannelindex', CommodityChannelIndex],
	['crs', CRS],
	['custom', Price],
	['dividendyield', DividendYield],
	['dmi', DMI],
	['ema', EMA],
	['gsrecommendation', GSRecommendation],
	['highlow', HighLow],
	['horizontalannotation', HorizontalAnnotation],
	['ichimokucloud', IchimokuCloud],
	['linearregression', LinearRegression],
	['macd', MACD],
	['mae', MAE],
	['massindex', MassIndex],
	['momentum', Momentum],
	['moneyflow', MoneyFlow],
	['moneyflowindex', MoneyFlowIndex],
	['nrv', NRV],
	['onbalancevolume', OnBalanceVolume],
	['perange', PERange],
	['peratio', PERatio],
	['percentb', PercentB],
	['previousclose', PreviousClose],
	['price', Price],
	['pricechannel', PriceChannel],
	['proc', PROC],
	['psar', PSAR],
	['revenues', Revenues],
	['rollingdividend', RollingDividend],
	['rollingeps', RollingEPS],
	['rsi', RSI],
	['sectorindustry', SectorIndustry],
	['sma', SMA],
	['stochastics', Stochastics],
	['tsf', TSF],
	['ultimateoscillator', UltimateOscillator],
	['updownnyse', UpDownRatio], // NXC-411, for backwards-compatibility
	['updownratio', UpDownRatio],
	['updown', UpDown],
	['volume', Volume],
	['volumebyprice', VolumeByPrice],
	['vroc', VROC],
	['vwap', VWAP],
	['williamspctr', WilliamsPctR],
	['wma', WMA],
	['yieldspread', YieldSpread]
]);
